import React, { forwardRef } from 'react';
var SubmitButton = forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("button", Object.assign({
    ref: ref
  }, props, {
    type: "submit"
  }));
});
export { SubmitButton };